import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../../models/base/base.component';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'location-detail',
  templateUrl: './location-detail.component.html',
  providers: []
})
export class LocationDetailComponent extends BaseComponent implements OnInit {
  @Input() model: any = null;
  @Input() showModal: boolean = true;
  @Input() showNotes: boolean = true;
  isAdmin: boolean = false;
  userRole: number = 0;
  showNotesAdd: boolean = false;
  metadata = {};

  constructor(private navigationService: NavigationService) {
    super();
  }

  ngOnInit() {
    this.isAdmin = !!localStorage.getItem('isAdmin');
    this.userRole = +localStorage.getItem('userRole');

    this.setPermissions();

    if (this.model != null) {
      this.metadata = this.model.metadata;
    }
  }

  close() {
    this.navigationService.showDetail(false);
  }

  setPermissions() {
    if (this.userRole == 3 || this.isAdmin) {
      this.showNotesAdd = true;
    }
  }

}
